import { render, staticRenderFns } from "./task-component.vue?vue&type=template&id=77a1e15b&"
import script from "./task-component.vue?vue&type=script&lang=js&"
export * from "./task-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports